/** Only routes verified in the API and MSW may produce request diagnostics. */
export const REPORT_REQUEST_TEMPLATES = [
  '/api/v1/seller/orders',
  '/api/v1/seller/orders/{order_id}',
  '/api/v1/admin/inventory/skus',
  '/api/v1/admin/shipping/purchase-label',
  '/api/v1/supply/my-work-orders',
  '/api/v1/supply/my-work-orders/{work_order_id}',
] as const

export const REPORT_ACTION_IDS = ['navigation.seller.orders', 'navigation.admin.inventory', 'navigation.supply.work_orders'] as const

const ORDER_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function matchReportRequest(method: string, path: string): string | null {
  if (method.toUpperCase() === 'POST' && path === '/api/v1/admin/shipping/purchase-label') return REPORT_REQUEST_TEMPLATES[3]
  if (method.toUpperCase() !== 'GET') return null
  if (path === '/api/v1/supply/my-work-orders') return REPORT_REQUEST_TEMPLATES[4]
  const supplyPrefix = '/api/v1/supply/my-work-orders/'
  if (path.startsWith(supplyPrefix) && ORDER_ID.test(path.slice(supplyPrefix.length))) return REPORT_REQUEST_TEMPLATES[5]
  if (path === '/api/v1/seller/orders') return REPORT_REQUEST_TEMPLATES[0]
  if (path === '/api/v1/admin/inventory/skus') return REPORT_REQUEST_TEMPLATES[2]
  const prefix = '/api/v1/seller/orders/'
  if (path.startsWith(prefix) && ORDER_ID.test(path.slice(prefix.length))) {
    return REPORT_REQUEST_TEMPLATES[1]
  }
  return null
}

const UUID_SEGMENT = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const OWN_REPORT = new RegExp(`^/problem-reports(?:/(?:capabilities|notifications(?:/${UUID_SEGMENT}/target)?|${UUID_SEGMENT}(?:/confirmation|/attachments/(?:upload|confirm|${UUID_SEGMENT}/download))?))?$`)
const ADMIN_REPORT = new RegExp(`^/admin/problem-reports(?:/(?:assignees|notifications/${UUID_SEGMENT}/target|${UUID_SEGMENT}(?:/commands|/attachments/${UUID_SEGMENT}/download)?))?$`)

export function isProblemReportApiUrl(url: string, apiBase: string, origin: string): boolean {
  try {
    const base = new URL(apiBase, origin)
    const target = new URL(url, origin)
    if (base.origin !== target.origin || !target.pathname.startsWith(`${base.pathname}/`)) return false
    const path = target.pathname.slice(base.pathname.length)
    return OWN_REPORT.test(path) || ADMIN_REPORT.test(path)
  } catch { return false }
}

const ROUTES: Readonly<Record<string, string>> = {
  '/seller/my-orders': 'seller.orders',
  '/seller/my-orders/$id': 'seller.orders',
  '/admin/inventory': 'admin.inventory',
  '/supply/work-orders': 'supply.work_orders',
  '/supply/work-orders/$id': 'supply.work_orders',
}
export const reportRouteName = (routeId: string): string => Object.hasOwn(ROUTES, routeId) ? ROUTES[routeId] : 'unknown'
export function reportShell(pathname: string): 'admin' | 'seller' | 'supply' | null {
  const segment = /^\/(admin|seller|supply)(?:\/|$)/.exec(pathname)?.[1]
  return segment === 'admin' || segment === 'seller' || segment === 'supply' ? segment : null
}
